<div class="row">
    <div class="col-6">
        <h1>Usuarios</h1>
    </div>
    <div class="col-6 ">
            <app-add-users></app-add-users>
    </div>
</div>

<!--app-users-->
<div class="row">
    <div class="col-md-12">
        <div class="card">
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table">
                    <thead>
                        <tr>
                        <th scope="col">Id</th>
                        <th scope="col">Nombre</th>
                        <th scope="col">Teléfono</th>
                        <th scope="col">Email</th>
                        <th scope="col">Role</th>
                        <th scope="col">Status</th>
                        <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let user of users">
                        <td>{{ user.id }}</td>
                        <td>{{ user.fullname }}</td>
                        <td>{{ user.telephone }}</td>
                        <td>{{ user.email }}</td>
                        <td *ngIf="user.idRole == 1">Admin</td>
                        <td *ngIf="user.idRole == 2">Productor</td>
                        <td *ngIf="user.idRole == null"></td>
                        <td *ngIf="user.active">Active</td>
                        <td *ngIf="!user.active">Inactive</td>
                        <td><button type="button" (click)="userDetails(user)" class="btn btn-secondary" data-toggle="modal" data-target="#editUserModal">Editar</button></td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<app-edit-users [userData]="userEdit"></app-edit-users>

<div *ngIf="loading" class="d-flex justify-content-center loading-screen">
    <div class="spinner-border" role="status">
      <span class="sr-only"></span>
    </div>
  </div>